module.exports = __webpack_public_path__ + "images/backgrounds/cosmos/full.92448e055514fdc92923.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/cosmos/full.jpg
// module id = eGww
// module chunks = 2